import { useEffect, useRef } from 'react';

/**
 * Listens for the `company-changed` custom event dispatched by CompanyContext
 * when the user switches companies, and invokes the provided callback.
 *
 * This mirrors the pattern used in EBTimeEntry to ensure every data-fetching
 * page/hook refetches with the new company context.
 *
 * @param callback - function to call when the active company changes
 * @param deps - additional dependencies that should cause the listener to be
 *               re-bound (e.g. screen mode, fetch functions)
 */
export function useCompanyChange(callback: () => void, deps: unknown[] = []) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const handler = () => callbackRef.current();
    window.addEventListener('company-changed', handler);
    return () => window.removeEventListener('company-changed', handler);
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
}
